import { Helmet } from 'react-helmet';

const SocialMetaTags = () => {
  // Aseguramos que usamos URLs absolutas
  const baseUrl = 'https://trenquelauquen.gov.ar';
  const imageUrl = `${baseUrl}/pp/img/pp-logo.png`;
  
  return (
    <Helmet>
      {/* Meta tags básicos */}
      <title>Presupuesto Participativo - Municipalidad de Trenque Lauquen</title>
      <meta name="description" content="Participá en las decisiones de tu ciudad. Conocé y votá los proyectos del Presupuesto Participativo de Trenque Lauquen." />

      {/* Meta tags para Facebook y WhatsApp */}
      <meta property="og:url" content={`${baseUrl}/pp`} />
      <meta property="og:type" content="website" />
      <meta property="og:title" content="Presupuesto Participativo - Trenque Lauquen" />
      <meta property="og:description" content="Participá en las decisiones de tu ciudad. Conocé y votá los proyectos del Presupuesto Participativo de Trenque Lauquen." />
      <meta property="og:image" content={imageUrl} />
      <meta property="og:image:secure_url" content={imageUrl} />
      <meta property="og:site_name" content="Municipalidad de Trenque Lauquen" />
      <meta property="og:locale" content="es_AR" />

      {/* Meta tags para Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta property="twitter:domain" content="trenquelauquen.gov.ar" />
      <meta property="twitter:url" content={`${baseUrl}/pp`} />
      <meta name="twitter:title" content="Presupuesto Participativo - Trenque Lauquen" />
      <meta name="twitter:description" content="Participá en las decisiones de tu ciudad. Conocé y votá los proyectos del Presupuesto Participativo de Trenque Lauquen." />
      <meta name="twitter:image" content={imageUrl} />
    </Helmet>
  );
};

export default SocialMetaTags;